import { render, staticRenderFns } from "./AppAnnotationPart7.vue?vue&type=template&id=7a8320b0&scoped=true"
import script from "./AppAnnotationPart7.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart7.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart7.vue?vue&type=style&index=0&id=7a8320b0&prod&lang=css"
import style1 from "./AppAnnotationPart7.vue?vue&type=style&index=1&id=7a8320b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8320b0",
  null
  
)

export default component.exports